const commonTranslations = {
    en: {
        privacy: 'Privacy notice',
        textShowMore: 'Show more',
        textShowLess: 'Show less',
        save: 'Save',
        cancel: 'Cancel',
        reset: 'Reset',
        yes: 'Yes',
        no: 'No',
        backToList: 'Back to list',
        inputs: {
            autocomplete: {
                noOptionsText: 'No results',
                loadingText: 'Loading…',
                typeAtLeast: 'Type at least {{count}} characters',
                fetchError: 'Error fetching results'
            },
            edit: 'Edit'
        },
        errorScreen: {
            loadFailed: 'Failed to load data',
            description: 'Please try again or contact support if the problem persists',
            refresh: 'Refresh'
        },
        commonEntities: {
            role: 'Role',
            roles: 'Roles',
            skill: 'Skill',
            skills: 'Skills',
            speciality: 'Speciality',
            specialities: 'Specialities'
        },
        dateRangePicker: {
            shortcuts: {
                nextWeek: 'Next week',
                nextMonth: 'Next month',
                currentMonth: 'Current month',
                nextMonthFromNowRange: 'Month from now',
                next3MonthsFromNow: '3 months from now',
                reset: 'Reset'
            }
        }
    },
    no: {
        privacy: 'Personvernerklæring',
        textShowMore: 'Vis mer',
        textShowLess: 'Vis mindre',
        save: 'Lagre',
        cancel: 'Avbryt',
        yes: 'Ja',
        no: 'Nei',
        backToList: 'Tilbake til listen',
        inputs: {
            autocomplete: {
                noOptionsText: 'Ingen resultater',
                loadingText: 'Laster…',
                typeAtLeast: 'Skriv minst {{count}} tegn',
                fetchError: 'Feil ved henting av resultater'
            },
            edit: 'Rediger'
        },
        errorScreen: {
            loadFailed: 'Kunne ikke laste data',
            description: 'Vennligst prøv igjen eller kontakt support hvis problemet vedvarer',
            refresh: 'Oppdater'
        },
        commonEntities: {
            role: 'Rolle',
            roles: 'Roller',
            skill: 'Ferdighet',
            skills: 'Ferdigheter',
            speciality: 'Spesialitet',
            specialities: 'Spesialiteter'
        },
        dateRangePicker: {
            shortcuts: {
                nextWeek: 'Neste uke',
                nextMonth: 'Neste måned',
                currentMonth: 'Nåværende måned',
                nextMonthFromNowRange: 'Måned fra nå',
                next3MonthsFromNow: '3 måneder fra nå',
                reset: 'Tilbakestill'
            }
        }
    },
    sv: {
        privacy: 'Sekretessmeddelande',
        textShowMore: 'Visa mer',
        textShowLess: 'Visa mindre',
        save: 'Spara',
        cancel: 'Avbryt',
        yes: 'Ja',
        no: 'Nej',
        backToList: 'Tillbaka till listan',
        inputs: {
            autocomplete: {
                noOptionsText: 'Inga resultat',
                loadingText: 'Läser in…',
                typeAtLeast: 'Skriv minst {{count}} tecken',
                fetchError: 'Fel vid hämtning av resultat'
            },
            edit: 'Redigera'
        },
        errorScreen: {
            loadFailed: 'Kunde inte ladda data',
            description: 'Försök igen eller kontakta support om problemet kvarstår',
            refresh: 'Uppdatera'
        },
        commonEntities: {
            role: 'Roll',
            roles: 'Roller',
            skill: 'Färdighet',
            skills: 'Färdigheter',
            speciality: 'Specialitet',
            specialities: 'Specialiteter'
        },
        dateRangePicker: {
            shortcuts: {
                nextWeek: 'Nästa vecka',
                nextMonth: 'Nästa månad',
                currentMonth: 'Nuvarande månad',
                nextMonthFromNowRange: 'Månad från nu',
                next3MonthsFromNow: '3 månader från nu',
                reset: 'Återställ'
            }
        }
    }
} as const;

export default commonTranslations;
